/** Lead-supply systems palette — indigo governance, emerald delivery, amber certification. */
export const eigenLeadsPalette = (isDark) => ({
  bg: isDark ? '#0a0c14' : '#f8f9fc',
  grid: isDark ? '#1e2235' : '#dde2ef',
  label: isDark ? '#f1f5f9' : '#0f172a',
  muted: isDark ? '#64748b' : '#64748b',
  indigo: isDark ? '#818cf8' : '#4f46e5',
  indigoSoft: isDark ? '#6366f1' : '#6366f1',
  emerald: isDark ? '#34d399' : '#059669',
  emeraldSoft: isDark ? '#4ade80' : '#10b981',
  amber: isDark ? '#fbbf24' : '#d97706',
  rose: isDark ? '#fb7185' : '#e11d48',
  panel: isDark ? '#0f1219' : '#ffffff',
  panelStroke: isDark ? '#334155' : '#c7d2e8',
  mono: isDark ? '#a5b4fc' : '#4338ca',
  accent: isDark ? '#818cf8' : '#4f46e5',
  accentSoft: isDark ? '#6366f1' : '#6366f1',
});

export const elType = {
  section: {
    fontFamily: 'system-ui, -apple-system, sans-serif',
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: '0.28em',
  },
  title: {
    fontFamily: 'system-ui, -apple-system, sans-serif',
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.06em',
  },
  sub: {
    fontFamily: 'system-ui, -apple-system, sans-serif',
    fontSize: 9,
    fontWeight: 500,
  },
  mono: {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    fontSize: 9,
    fontWeight: 500,
    letterSpacing: '0.04em',
  },
  monoSm: {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    fontSize: 8,
    fontWeight: 500,
    letterSpacing: '0.03em',
  },
};
